import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const userVuex = createNamespacedHelpers("user");
export default {
  name: "referral",
  computed: {
    ...walletVuex.mapState(["isMobile", "netId", "isConnect", "isWallet"]),
    ...userVuex.mapState(["botInfo", "userInfo", "web3Data"]),
    TelegramRefrralLink() {
      if (this.userInfo) {
        return `https://t.me/share/url?text=${this.botInfo.invite}&url=${this.botInfo.bot}/game?startapp=ref_${this.userInfo["ref_code"]}`;
      }
    },
    ReferralLink() {
      if (this.userInfo) {
        return `${this.botInfo.app}/?ref=${this.userInfo.ref_code}`;
      }
    },
    ReferralCode() {
      if (this.userInfo) {
        return `${this.userInfo.ref_code}`;
      }
    }
  },
  data() {
    return {
      userRefPower: null,
      userPower: null,
      refrralText: null
    };
  },
  watch: {
    isWallet: {
      handler(bool) {
        if (bool) {
          this.web3Wallet.web3WindQueryFn();
        }
      },
      deep: true,
      immediate: true
    },
    "userInfo.bind": {
      handler(val) {
        console.log("userInfo.bind", val);
        if (val === null) return;
        if (val === 0) {
          const refCode = localStorage.getItem("refCode");
          const referralEncode = this.userInfo?.referral_encode;
          if (refCode || referralEncode) {
            this.refrralText = refCode || referralEncode;
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...walletVuex.mapActions(["doConnect"]),
    ...userVuex.mapActions(["getLoginInfo"]),
    async walletWeb3Init() {
      await this.noWalletWeb3Init();
    },
    async noWalletWeb3Init() {
      // this.userRefPower = this.web3Wallet.userRefPower.label;
    },
    onCopy(str) {
      let tip = str.trim().replace(/\s+/g, " ").split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" "); // 重新组合为字符串

      let linkname = tip.replace(/\s+/g, "").replace(/^./, str => str.toUpperCase());
      console.log("linkname", linkname, this[linkname]);
      this.$copyText(this[linkname]).then(this.$toasted.success(`${tip} Copied!`));
    },
    async onReferralSave() {
      const res = await this.getLoginInfo([this.refrralText, "refCode"]);
      if (res) {
        this.$toasted.success("Save success!");
      }
    }
  },
  async mounted() {
    await this.walletWeb3Init();
  }
};